import axios from '@/axios.js'
import hr from '../../http/requests/hrms/index.js'
import photoUpload from '../../http/requests/photo/index.js'
import getters from '../getters.js'
export default {
    addLeave({ commit }, items) {
        return new Promise((resolve, reject) => {
            axios.post('/api/leave', items)
              .then((response) => {
                commit('ADD_LEAVE', response.data.data)//Object.assign(items, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
                resolve(response)
              })
              .catch((error) => { reject(error) })
        })
    },
    updateLeave({ commit }, items) {
      return new Promise((resolve, reject) => {
          axios.put('/api/leave', items)
            .then((response) => {
              commit('UPDATE_LEAVE', Object.assign(items, {approversLMs: response.data.data.approversLMs}))
              resolve(response)
            })
            .catch((error) => {console.log(error)
               reject(error) })
      })
    },
    getAllLeaves({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get('/api/leave', { params : { 
                sortBy: payload.sortBy,
                sortOrder: payload.sortOrder,
                pageNumber: payload.pageNumber,
                pageSize: payload.pageSize,
                isApprover: payload.isApprover
            }})
              .then((response) => {
                commit('GET_ALL_LEAVE',  response.data.data)
                resolve(response)
              })
              .catch((error) => { reject(error) })
        })
    },
    getAllApproversByModule({commit}, items) {
        return new Promise((resolve, reject) => {
          hr.getAllApproversByModule(items.module, items.userId)
            .then((response) => {
              commit('GET_ALL_APPROVERS',  response.data.data)
              resolve(response)
            })
            .catch((error) => { reject(error) })
        })
    },
    unSubmit({commit}, items) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/leave/${items.employeeFiledLeaveId}`, {
          action: items.action,
          isDraft: items.isDraft,
          isSubmitted: items.isSubmitted,
          approverId: items.approverId
        })
          .then((response) => {
            commit('UNSUBMIT_LEAVE', items.employeeFiledLeaveId)//Object.assign(items, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
        })
    },
    onCancelled({commit}, items) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/leave/${items.employeeFiledLeaveId}`, {
          action: items.action,
          isDraft: items.isDraft,
          isSubmitted: items.isSubmitted,
          isCancelled: items.isCancelled,
          cancelledOn: items.cancelledOn,
          isRevised: items.isRevised,
          remarks: items.remarks,
          approverId: items.approverId
        })
          .then((response) => {
            commit('CANCELLED_LEAVE', items)//Object.assign(items, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
        })
    },
    onRetracked({commit}, items) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/leave/${items.employeeFiledLeaveId}`, {
          action: items.action,
          isDraft: items.isDraft,
          isRetracted: items.isRetracted,
          retractedOn: items.retractedOn,
          isApproved: items.isApproved,
          remarks: items.remarks,
          approverId: items.approverId
        })
          .then((response) => {
            commit('RETRACKED_LEAVE', items)//Object.assign(items, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
        })
    },
    onApproved({commit}, items) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/leave/${items.employeeFiledLeaveId}`, {
          action: items.action,
          isUnread : items.isUnread, 
          isApproved: items.isApproved, 
          approvedOn : items.approvedOn, 
          isRetracted : items.isRetracted, 
          approverId: items.approverId
        })
          .then((response) => {
            commit('APPROVED_LEAVE', items)//Object.assign(items, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
        })
    },
    onDenied({commit}, items) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/leave/${items.employeeFiledLeaveId}`, {
          action: items.action,
          isUnread : items.isUnread, 
          isDenied: items.isDenied, 
          deniedOn : items.deniedOn, 
          isRetracted : items.isRetracted, 
          comments: items.comments,
          approverId: items.approverId
        })
          .then((response) => {
            commit('DENIED_LEAVE', items)//Object.assign(items, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
        })
    },
    onRevised({commit}, items) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/leave/${items.employeeFiledLeaveId}`, {
          action: items.action,
          // isDraft: items.isDraft,
          // isSubmitted: items.isSubmitted,
          isUnread : items.isUnread, 
          isRevised: items.isRevised, 
          forRevisionOn : items.forRevisionOn, 
          isRetracted : items.isRetracted, 
          comments: items.comments,
          approverId: items.approverId
        })
          .then((response) => {
            commit('REVISED_LEAVE', items)//Object.assign(items, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
        })
    },
    uploadPhoto({ commit }, items) {
      //console.log('pasok eh noh')
      var config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      };
      return new Promise((resolve, reject) => {
          // photoUpload.uploadPhoto(items.UserId, items.Title, Description, IsPublic, Type, FileName, file)
          axios.post('/api/photo/upload', items, config)
            
            .then((response) => {
              //console.log('x')
              commit('UPLOAD_PHOTO', Object.assign(items, {id: response.data.id}))
              resolve(response)
            })
            .catch((error) => { reject(error) })
      })
  },
  deletePhoto({commit}, photoId) {
     return new Promise((resolve, reject) => {
        axios.delete(`/api/photo/${photoId}`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
     })
  }
}